// bootstrap component
import { Card as BsCard } from 'react-bootstrap'

// styles
import classes from './styles.module.scss'

// types
import type { sizeEnums, variantsEnum } from '@centria-ui/commons/enums'
import type { CardProps } from 'react-bootstrap/Card'
import type { FC } from 'react'

export interface SectionProps extends CardProps {
  cardBorder?: boolean
  size?: keyof typeof sizeEnums
  variant?: Extract<keyof typeof variantsEnum, 'white' | 'light' | 'warning'>
}

export const Section: FC<SectionProps> = ({
  children,
  size = 'md',
  className = '',
  variant = 'white',
  cardBorder = true,
  ...props
}) => (
  <BsCard
    {...props}
    role={props.onClick ? 'button' : undefined}
    className={`${className} ${classes[`section_${variant}`]} ${
      size && classes[`section_${size}`]
    } ${!cardBorder && classes.section_border}`}>
    {children}
  </BsCard>
)
